/*
 * Русский перевод плагина каталога (страница каталога, карточки сущности, диалоги) и его
 * React-части (фильтры, колонки таблиц, инспектор сущности).
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react';

const catalogRu = createTranslationMessages({
  ref: catalogTranslationRef,
  full: false,
  messages: {
    'indexPage.title': 'Каталог {{orgName}}',
    'indexPage.createButtonTitle': 'Создать',
    'indexPage.supportButtonContent': 'Все сущности каталога платформы',
    'entityPage.notFoundMessage': 'Нет {{kind}} с запрошенными {{link}}.',
    'entityPage.notFoundLinkText': 'видом, пространством имён и именем',
    'aboutCard.title': 'О сущности',
    'aboutCard.refreshButtonTitle': 'Запланировать обновление сущности',
    'aboutCard.editButtonTitle': 'Редактировать метаданные',
    'aboutCard.editButtonAriaLabel': 'Редактировать',
    'aboutCard.createSimilarButtonTitle': 'Создать похожее',
    'aboutCard.refreshScheduledMessage': 'Обновление запланировано',
    'aboutCard.refreshButtonAriaLabel': 'Обновить',
    'aboutCard.launchTemplate': 'Запустить шаблон',
    'aboutCard.viewTechdocs': 'Документация',
    'aboutCard.viewSource': 'Исходный код',
    'aboutCard.unknown': 'неизвестно',
    'aboutCard.descriptionField.label': 'Описание',
    'aboutCard.descriptionField.value': 'Без описания',
    'aboutCard.ownerField.label': 'Владелец',
    'aboutCard.ownerField.value': 'Нет владельца',
    'aboutCard.domainField.label': 'Домен',
    'aboutCard.domainField.value': 'Без домена',
    'aboutCard.systemField.label': 'Система',
    'aboutCard.systemField.value': 'Без системы',
    'aboutCard.parentComponentField.label': 'Родительский компонент',
    'aboutCard.parentComponentField.value': 'Нет родительского компонента',
    'aboutCard.kindField.label': 'Вид',
    'aboutCard.typeField.label': 'Тип',
    'aboutCard.lifecycleField.label': 'Стадия',
    'aboutCard.tagsField.label': 'Тэги',
    'aboutCard.tagsField.value': 'Без тэгов',
    'aboutCard.targetsField.label': 'Цели',
    'searchResultItem.kind': 'Вид',
    'searchResultItem.type': 'Тип',
    'searchResultItem.lifecycle': 'Стадия',
    'searchResultItem.owner': 'Владелец',
    'catalogTable.warningPanelTitle': 'Не удалось загрузить сущности каталога.',
    'catalogTable.viewActionTitle': 'Открыть',
    'catalogTable.editActionTitle': 'Редактировать',
    'catalogTable.starActionTitle': 'В избранное',
    'catalogTable.unStarActionTitle': 'Убрать из избранного',
    'catalogTable.allFilters': 'Все',
    'dependencyOfComponentsCard.title': 'От неё зависят компоненты',
    'dependencyOfComponentsCard.emptyMessage':
      'Ни один компонент не зависит от этого компонента.',
    'dependsOnComponentsCard.title': 'Зависит от компонентов',
    'dependsOnComponentsCard.emptyMessage':
      'Этот компонент не зависит от других компонентов.',
    'dependsOnResourcesCard.title': 'Зависит от ресурсов',
    'dependsOnResourcesCard.emptyMessage':
      'Этот компонент не зависит от ресурсов.',
    'entityContextMenu.copiedMessage': 'Скопировано',
    'entityContextMenu.moreButtonTitle': 'Ещё',
    'entityContextMenu.inspectMenuTitle': 'Инспектор сущности',
    'entityContextMenu.copyURLMenuTitle': 'Скопировать ссылку на сущность',
    'entityContextMenu.unregisterMenuTitle': 'Снять с регистрации',
    'entityContextMenu.moreButtonAriaLabel': 'Другие действия',
    'entityLabelsCard.title': 'Метки',
    'entityLabelsCard.columnKeyLabel': 'Метка',
    'entityLabelsCard.columnValueLabel': 'Значение',
    'entityLabelsCard.emptyDescription':
      'У сущности нет меток. Добавьте их в YAML сущности, как в примере ниже:',
    'entityLabelsCard.readMoreButtonTitle': 'Подробнее',
    'entityLabels.warningPanelTitle': 'Сущность не найдена',
    'entityLabels.ownerLabel': 'Владелец',
    'entityLabels.lifecycleLabel': 'Стадия',
    'entityLabels.systemLabel': 'Система',
    'entityLabels.domainLabel': 'Домен',
    'entityLabels.partOfLabel': 'Часть',
    'entityLinksCard.title': 'Ссылки',
    'entityLinksCard.emptyDescription':
      'У сущности нет ссылок. Добавьте их в YAML сущности, как в примере ниже:',
    'entityLinksCard.readMoreButtonTitle': 'Подробнее',
    'entityNotFound.title': 'Сущность не найдена',
    'entityNotFound.description':
      'Как описать сущность — в документации по каталогу.',
    'entityNotFound.docButtonTitle': 'ДОКУМЕНТАЦИЯ',
    'entityTabs.tabsAriaLabel': 'Вкладки',
    'deleteEntity.dialogTitle': 'Удалить эту сущность?',
    'deleteEntity.deleteButtonTitle': 'Удалить',
    'deleteEntity.cancelButtonTitle': 'Отмена',
    'deleteEntity.description':
      'На эту сущность не ссылается ни одна локация, поэтому она не обновляется.',
    'deleteEntity.actionButtonTitle': 'Удалить сущность',
    'catalogExportButton.triggerButtonTitle': 'Экспорт выборки',
    'catalogExportButton.dialogTitle': 'Экспорт выборки каталога',
    'catalogExportButton.formatLabel': 'Формат',
    'catalogExportButton.columnsLabel': 'Колонки',
    'catalogExportButton.cancelButtonTitle': 'Отмена',
    'catalogExportButton.confirmButtonTitle': 'Экспортировать',
    'catalogExportButton.exportingButtonTitle': 'Экспорт…',
    'catalogExportButton.successMessage': 'Каталог экспортирован',
    'catalogExportButton.errorMessage':
      'Не удалось экспортировать каталог: {{errorMessage}}',
    entityProcessingErrorsDescription: 'Источник ошибки ниже:',
    entityRelationWarningDescription:
      'У сущности есть связи с сущностями, которых нет в каталоге.\n Не найдены: ',
    'hasComponentsCard.title': 'Компоненты',
    'hasComponentsCard.emptyMessage': 'В этой системе нет компонентов.',
    'hasResourcesCard.title': 'Ресурсы',
    'hasResourcesCard.emptyMessage': 'В этой системе нет ресурсов.',
    'hasSubcomponentsCard.title': 'Подкомпоненты',
    'hasSubcomponentsCard.emptyMessage':
      'У этого компонента нет подкомпонентов.',
    'hasSubdomainsCard.title': 'Поддомены',
    'hasSubdomainsCard.emptyMessage': 'В этом домене нет поддоменов.',
    'hasSystemsCard.title': 'Системы',
    'hasSystemsCard.emptyMessage': 'В этом домене нет систем.',
    'relatedEntitiesCard.emptyHelpLinkTitle': 'Как это изменить',
    'systemDiagramCard.title': 'Схема системы',
    'systemDiagramCard.description':
      'Масштабируйте и перемещайте схему жестами.',
    'systemDiagramCard.edgeLabels.partOf': 'часть',
    'systemDiagramCard.edgeLabels.provides': 'предоставляет',
    'systemDiagramCard.edgeLabels.dependsOn': 'зависит от',
  },
});

/** Формы «несколько/много» для языка ru — таких ключей нет в типе ref, поэтому отдельно. */
const catalogReactPlurals: Record<string, string> = {
  'missingAnnotationEmptyState.generateDescription_few':
    'Не хватает аннотаций {{annotations}}. Добавьте их в {{entityKind}}, чтобы включить этот инструмент.',
  'missingAnnotationEmptyState.generateDescription_many':
    'Не хватает аннотаций {{annotations}}. Добавьте их в {{entityKind}}, чтобы включить этот инструмент.',
};

const catalogReactRu = createTranslationMessages({
  ref: catalogReactTranslationRef,
  full: false,
  messages: {
    ...catalogReactPlurals,
    'catalogFilter.title': 'Фильтры',
    'catalogFilter.buttonTitle': 'Фильтры',
    'entityKindPicker.title': 'Вид',
    'entityKindPicker.errorMessage': 'Не удалось загрузить виды сущностей',
    'entityLifecyclePicker.title': 'Стадия',
    'entityNamespacePicker.title': 'Пространство имён',
    'entityOwnerPicker.title': 'Владелец',
    'entityProcessingStatusPicker.title': 'Состояние обработки',
    'entityTagPicker.title': 'Тэги',
    'entityPeekAheadPopover.title':
      'Откройте сущность, чтобы увидеть все тэги.',
    'entityPeekAheadPopover.emailCardAction.title': 'Написать {{email}}',
    'entityPeekAheadPopover.emailCardAction.subTitle': 'mailto {{email}}',
    'entityPeekAheadPopover.emailCardAction.ariaLabel': 'Написать',
    'entityPeekAheadPopover.entityCardActionsAriaLabel': 'Открыть',
    'entityPeekAheadPopover.entityCardActionsTitle': 'Подробнее',
    'entitySearchBar.placeholder': 'Поиск',
    'entityTypePicker.title': 'Тип',
    'entityTypePicker.errorMessage': 'Не удалось загрузить типы сущностей',
    'entityTypePicker.optionAllTitle': 'все',
    'favoriteEntity.addToFavorites': 'В избранное',
    'favoriteEntity.removeFromFavorites': 'Убрать из избранного',
    'inspectEntityDialog.title': 'Инспектор сущности',
    'inspectEntityDialog.closeButtonTitle': 'Закрыть',
    'inspectEntityDialog.ancestryPage.title': 'Происхождение',
    'inspectEntityDialog.ancestryPage.description':
      'Цепочка сущностей, из которых произошла текущая: {{processorsLink}} дочерние сущности, которые в итоге привели к её появлению. Это не то же самое, что связи.',
    'inspectEntityDialog.ancestryPage.processorsLink': 'процессоры породили',
    'inspectEntityDialog.colocatedPage.title': 'Соседи',
    'inspectEntityDialog.colocatedPage.description':
      'Сущности из того же источника данных (например, из того же YAML-файла) или того же происхождения (изначально зарегистрированного URL).',
    'inspectEntityDialog.colocatedPage.alertNoLocation':
      'У сущности нет сведений о локации.',
    'inspectEntityDialog.colocatedPage.alertNoEntity':
      'Других сущностей в этой локации нет.',
    'inspectEntityDialog.colocatedPage.locationHeader': 'В той же локации',
    'inspectEntityDialog.colocatedPage.originHeader': 'Того же происхождения',
    'inspectEntityDialog.colocatedPage.entityListAriaLabel':
      'Соседние сущности',
    'inspectEntityDialog.jsonPage.title': 'Сущность как JSON',
    'inspectEntityDialog.jsonPage.description':
      'Сырые данные сущности из каталога в формате JSON.',
    'inspectEntityDialog.overviewPage.title': 'Обзор',
    'inspectEntityDialog.overviewPage.relation.title': 'Связи',
    'inspectEntityDialog.overviewPage.status.title': 'Состояние',
    'inspectEntityDialog.overviewPage.identity.title': 'Идентичность',
    'inspectEntityDialog.overviewPage.metadata.title': 'Метаданные',
    'inspectEntityDialog.overviewPage.annotations': 'Аннотации',
    'inspectEntityDialog.overviewPage.labels': 'Метки',
    'inspectEntityDialog.overviewPage.tags': 'Тэги',
    'inspectEntityDialog.overviewPage.copyAriaLabel': 'Скопировать {{label}}',
    'inspectEntityDialog.overviewPage.copiedStatus': 'Скопировано',
    'inspectEntityDialog.overviewPage.helpLinkAriaLabel': 'Подробнее',
    'inspectEntityDialog.yamlPage.title': 'Сущность как YAML',
    'inspectEntityDialog.yamlPage.description':
      'Сырые данные сущности из каталога в формате YAML.',
    'inspectEntityDialog.tabNames.overview': 'Обзор',
    'inspectEntityDialog.tabNames.ancestry': 'Происхождение',
    'inspectEntityDialog.tabNames.colocated': 'Соседи',
    'inspectEntityDialog.tabNames.json': 'JSON',
    'inspectEntityDialog.tabNames.yaml': 'YAML',
    'inspectEntityDialog.tabsAriaLabel': 'Разделы инспектора',
    'unregisterEntityDialog.title': 'Снять эту сущность с регистрации?',
    'unregisterEntityDialog.cancelButtonTitle': 'Отмена',
    'unregisterEntityDialog.deleteButtonTitle': 'Удалить сущность',
    'unregisterEntityDialog.deleteEntitySuccessMessage':
      'Сущность {{entityName}} удалена',
    'unregisterEntityDialog.bootstrapState.title':
      'Эту сущность нельзя снять с регистрации: она задана защищённой конфигурацией платформы (локация «{{location}}»). Если это ошибка, обратитесь к администраторам {{appTitle}}.',
    'unregisterEntityDialog.bootstrapState.advancedDescription':
      'Можно удалить саму сущность из каталога. Делайте это, только если файл каталога удалён или перенесён из исходной локации, иначе сущность вскоре появится снова при очередном обновлении каталога.',
    'unregisterEntityDialog.bootstrapState.advancedOptions': 'Дополнительно',
    'unregisterEntityDialog.onlyDeleteStateTitle':
      'Эта сущность не происходит из зарегистрированной локации, поэтому её можно только удалить из каталога.',
    'unregisterEntityDialog.unregisterState.title':
      'Будут сняты с регистрации сущности:',
    'unregisterEntityDialog.unregisterState.subTitle': 'Из локации:',
    'unregisterEntityDialog.unregisterState.description':
      'Чтобы отменить, заново зарегистрируйте сущность в {{appTitle}}.',
    'unregisterEntityDialog.unregisterState.unregisterButtonTitle':
      'Снять локацию с регистрации',
    'unregisterEntityDialog.unregisterState.advancedOptions': 'Дополнительно',
    'unregisterEntityDialog.unregisterState.advancedDescription':
      'Также можно удалить саму сущность из каталога. Делайте это, только если файл каталога удалён или перенесён из исходной локации, иначе сущность вскоре появится снова при очередном обновлении каталога.',
    'unregisterEntityDialog.errorStateTitle':
      'Внутренняя ошибка: неизвестное состояние',
    'userListPicker.defaultOrgName': 'Платформа',
    'userListPicker.personalFilter.title': 'Личное',
    'userListPicker.personalFilter.ownedLabel': 'Мои',
    'userListPicker.personalFilter.starredLabel': 'Избранное',
    'userListPicker.orgFilterAllLabel': 'Все',
    'entityTableColumnTitle.name': 'Имя',
    'entityTableColumnTitle.system': 'Система',
    'entityTableColumnTitle.owner': 'Владелец',
    'entityTableColumnTitle.type': 'Тип',
    'entityTableColumnTitle.lifecycle': 'Стадия',
    'entityTableColumnTitle.namespace': 'Пространство имён',
    'entityTableColumnTitle.description': 'Описание',
    'entityTableColumnTitle.tags': 'Тэги',
    'entityTableColumnTitle.targets': 'Цели',
    'entityTableColumnTitle.title': 'Название',
    'entityTableColumnTitle.label': 'Метка',
    'entityTableColumnTitle.domain': 'Домен',
    'entityRelationCard.emptyHelpLinkTitle': 'Как это изменить',
    'missingAnnotationEmptyState.title': 'Нет аннотации',
    'missingAnnotationEmptyState.readMore': 'Подробнее',
    'missingAnnotationEmptyState.annotationYaml':
      'Добавьте аннотацию в YAML вашего {{entityKind}}, как в примере ниже:',
    'missingAnnotationEmptyState.generateDescription_one':
      'Не хватает аннотации {{annotations}}. Добавьте её в {{entityKind}}, чтобы включить этот инструмент.',
    'missingAnnotationEmptyState.generateDescription_other':
      'Не хватает аннотаций {{annotations}}. Добавьте их в {{entityKind}}, чтобы включить этот инструмент.',
  },
});

export const catalogTranslations = [
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: { ru: () => Promise.resolve({ default: catalogRu }) },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: { ru: () => Promise.resolve({ default: catalogReactRu }) },
  }),
];
